var lib_core  = require("lib-core");

var ErrorMessageView  = require("./errorMessageView.js");
var ErrorMessageModel = require("./errorMessageModel.js");

var ErrorMessageController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(ErrorMessageController, lib_core.Controller);

module.exports = ErrorMessageController;

ErrorMessageController.prototype.createModel = function () {
    var errorModel = new ErrorMessageModel(this.configuration);
    return errorModel;
};

ErrorMessageController.prototype.createView = function () {
    return new ErrorMessageView(this.root.editorHolder, this.getModel());
};
